const API_BASE_URL = process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'http://localhost:8000/api';

export const authFetch = (endpoint, options = {}) => {
  const token = localStorage.getItem('authToken') || localStorage.getItem('magicToken');

  const defaultHeaders = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Token ${token}` }),
  };

  // Ensure only one slash between base URL and endpoint
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;

  return fetch(`${API_BASE_URL}${normalizedEndpoint}`, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options.headers || {}),
    },
  });
};